import { defineMessages } from '@jutro/locale';

export default defineMessages({
    PeopleInvolved: {
        id: 'ml.claim.views.ml-claim-details-pa-involved.People Involved',
        defaultMessage: 'People Involved'
    },
    You: {
        id: 'ml.claim.views.ml-claim-details-pa-involved.You',
        defaultMessage: 'You'
    },
    License: {
        id: 'ml.claim.views.ml-claim-details-pa-involved.License',
        defaultMessage: 'License:'
    },
    Phone: {
        id: 'ml.claim.views.ml-claim-details-pa-involved.Phone',
        defaultMessage: 'Phone:'
    },
    YourDriver: {
        id: 'ml.claim.views.ml-claim-details-pa-involved.Your Driver',
        defaultMessage: 'Your Driver'
    },
    YourPassenger: {
        id: 'ml.claim.views.ml-claim-details-pa-involved.Your Passenger',
        defaultMessage: 'Your Passenger'
    },
});
